<h1 mat-dialog-title>{{ data.title | translate }}</h1>

<form class="igo-form" [formGroup]="formGroup">
  <section class="choices-section">
    @for (choice of data.choices; track choice; let i = $index) {
      @if (data.type === 'checkbox') {
        <mat-checkbox formControlName="{{ choice.value }}">{{
          choice.title || choice.value
        }}</mat-checkbox>
      }
    }

    @if (data.type === 'radio') {
      <mat-radio-group (change)="onChange($event)">
        @for (choice of data.choices; track choice) {
          <mat-radio-button [value]="choice.value">
            {{ choice.title || choice.value }}
          </mat-radio-button>
        }
      </mat-radio-group>
    }
  </section>
  <div mat-dialog-actions>
    <div class="button-group">
      <button matButton="elevated" type="button" (click)="cancel()">
        {{ data.cancelButtonText | translate }}
      </button>
      <button
        [disabled]="isDisabled$ | async"
        id="processBtnDialog"
        matButton="elevated"
        type="button"
        color="primary"
        (click)="save()"
      >
        {{ data.processButtonText | translate }}
      </button>
    </div>
  </div>
</form>
